import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

export default ({ rateLimits, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (rateLimits.loading) {
      return "is Loading";
    }
    if (isEmpty(rateLimits.data)) {
      return <p className="is-size-2 has-text-centered has-text-grey">Found Nothing</p>;
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Label</th>
            <th>Value</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {rateLimits.data.map(rateLimit => (
            <tr key={rateLimit.id}>
              <td>
                <a>{rateLimit.id}</a>
              </td>
              <td>{rateLimit.label}</td>
              <td>{rateLimit.value}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link to={`/rate-limits/${rateLimit.id}/edit`} className="button  is-link is-small">
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(rateLimit.id)}
                    to={`/rate-limits/${rateLimit.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/RateLimit/Index/Table.js